// @ts-nocheck
import { createIcon } from "@chakra-ui/react";

const USDPlus = createIcon({
  displayName: "USDPlus",
  viewBox: "0 0 250 250",
  path: (
    <g>
      <radialGradient id="a" cx="8.25" cy="164.925" r="199.981" gradientUnits="userSpaceOnUse">
        <stop offset=".09" stop-color="#00522c" />
        <stop offset="1" stop-color="#00522c" stop-opacity="0" />
      </radialGradient>
      <radialGradient id="b" cx="238.137" cy="80.337" r="199.981" gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="#8ad137" />
        <stop offset="1" stop-color="#8ad137" stop-opacity="0" />
      </radialGradient>
      <path
        fill="#00a64f"
        d="M250 125c0 69.035-55.965 125-125 125S0 194.035 0 125 55.965 0 125 0s125 55.965 125 125zm0 0"
      />
      <path
        fill="url(#a)"
        d="M250 125c0 69.035-55.965 125-125 125S0 194.035 0 125 55.965 0 125 0s125 55.965 125 125zm0 0"
      />
      <path
        fill="url(#b)"
        d="M250 125c0 69.035-55.965 125-125 125S0 194.035 0 125 55.965 0 125 0s125 55.965 125 125zm0 0"
      />
      <path
        fill="#fff"
        d="M147.563 115.492h-10.625V84.324h46.312V65.2h-46.29V35.242h-23.89V65.32h-10.078c-21.781 0-39.941 11.004-39.941 35 0 20.985 15.926 34.192 39.375 34.192h10.625v31.164H66.75V184.8h46.29v29.96h23.89V184.68h10.078c21.781 0 39.941-11.004 39.941-35 0-20.98-15.926-34.188-39.387-34.188zM113.038 134.5v-19H105.5c-10.117 0-18.355-4.262-18.355-15.625 0-11.25 7.812-15.523 18.855-15.523h7.07v31.168h23.86v18.98zM144 165.676h-7.07v-31.168h7.57c10.117 0 18.355 4.262 18.355 15.625 0 11.293-7.812 15.543-18.855 15.543zm0 0"
      />
    </g>
  )
});

export default USDPlus;
